export default __webpack_public_path__ + "static/media/002-ensalada.231c1200.png";